import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SET_IS_SERVICES_ENABLED = 'PUBLISH_TERMS :: IS_SERVICES_ENABLED :: SET';

export type TSetIsServicesEnabledAction = IReduxAction<typeof SET_IS_SERVICES_ENABLED, boolean>;

export const setIsServicesEnabled = actionGenerator<typeof SET_IS_SERVICES_ENABLED, boolean>(SET_IS_SERVICES_ENABLED);
